module.exports = __webpack_public_path__ + "media/components/assets/img/bg/clouds-overlay-73c55e8651a302c365817307893ccf3c.svg";